<template>
  <section class="home-hero flex flex-column" id="home-hero-section">
    <div id="home-hero__wrapper">
      <scratch class="scratch-wrapper" v-if="isScratchActive && this.$store.getters.getIsWebView" />
      <div class="home-hero__title flex">
        <div class="flex">
          <div @mouseenter="bounceElement">
            <span class="bouncy">H </span>
          </div>

          <div @mouseenter="bounceElement">
            <span class="bouncy">e </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">l </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">l </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">o </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">,&nbsp;</span>
          </div>
        </div>
        <div class="flex">
          <div @mouseenter="bounceElement">
            <span class="bouncy">I</span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">' </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">m</span>
          </div>
          &nbsp;
          <div @mouseenter="
            (e) => {
              this.bounceElement(e, 'Y');
            }
          ">
            <span class="bouncy">Y</span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">o </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">n </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">g </span>
          </div>
          &nbsp;
          <div @mouseenter="
            (e) => {
              this.bounceElement(e, 'T');
            }
          ">
            <span class="bouncy">T</span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">i </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">n </span>
          </div>
          <div @mouseenter="bounceElement">
            <span class="bouncy">g</span>
          </div>
        </div>
      </div>
      <div id="sub-title" class="sub-title">
        <h3>Web Developer</h3>
      </div>
    </div>
    <div class="button-swipe-wrapper" id="button-swipe-wrapper">
      <div class="button-swipe" @click="isContactMe = true">
        <h3>contact me</h3>
      </div>
    </div>
    <contactMe v-if="isContactMe" @close="isContactMe = false" />
  </section>
</template>
<script>
import ContactMe from "./contactMe.vue";
import scratch from "./scratch.vue";
export default {
  components: { scratch, ContactMe },
  name: "home-hero",
  data() {
    return { isScratchActive: true, isContactMe: false };
  },
  mounted() {
    this.typingEffect();
  },
  methods: {
    bounceElement(e, letter = "AAA") {
      e.target.classList.add("bouncing");
      if (letter != "AAA") {
        e.target.classList.add("red");
        setTimeout(() => {
          e.target.classList.remove("red");
        }, 800);
      }
      e.target.addEventListener("animationend", () => {
        e.target.classList.remove("bouncing");
      });
    },
    typingEffect() {
      var collectionOfLetters = document.getElementsByClassName("bouncy");
      var size = Object.keys(collectionOfLetters).length;
      var i = 0;
      var interval = setInterval(function () {
        if (i < size) {
          var letterTarget = collectionOfLetters[i];
          letterTarget.classList.add("bouncy--show", "typing");
          letterTarget.addEventListener("animationend", () => {
            letterTarget.classList.remove("typing");
          });
          i++;
        } else {
          clearInterval(interval);
        }
      }, 180);

      var animationTiming = 3000;

      setTimeout(() => {
        document.getElementById("sub-title").classList.add("sub-title--fadeIn");
        document.getElementById("button-swipe-wrapper").classList.add("active");
      }, animationTiming);
      setTimeout(() => {
        this.isScratchActive = false;
      }, 3000);
    },
  },
};
</script>
<style lang="scss" scoped>
.button-swipe-wrapper {
  margin-top: 100px;
  opacity: 0;
  transition: opacity 1s;

  &.active {
    opacity: 1;
  }
}

.button-swipe {
  display: inline-block;
  padding: 5px 25px;
  color: darken(rgb(255, 255, 255), 10%);
  text-transform: uppercase;
  letter-spacing: 0.15rem;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  border: 1px solid #e6e6e6;
  border-radius: 5px;

  &:after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    z-index: -2;
  }

  &:before {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0%;
    height: 100%;
    border-radius: 5px;
    background-color: darken(rgb(255, 255, 255), 10%);
    transition: all 0.3s;
    z-index: -1;
  }

  &:hover {
    color: #161616;
    cursor: pointer;

    &:before {
      width: 100%;
    }
  }
}

#home-hero__wrapper {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.home-hero {
  font-family: "Archivo Black", sans-serif;
  color: #e6e6e6;
  position: relative;

  .home-hero__title {
    font-size: 4rem;
    position: relative;

    @media only screen and (max-width: 1080px) {
      flex-direction: column;
      text-align: left;
    }

    @media only screen and (max-width: 600px) {
      font-size: 2.5rem;
    }
  }
}

.bouncy {
  display: inline-block;
  opacity: 0;
}

.bouncing {
  animation: rubberband 600ms alternate ease-out;
  -webkit-animation: rubberband 600ms alternate ease-out;
  -moz-animation: rubberband 600ms alternate ease-out;
  -o-animation: rubberband 600ms alternate ease-out;

  &.red {
    color: red;
  }
}

.bouncy--show {
  opacity: 1;
}

.typing {
  -webkit-animation: typing 150ms ease-out;
  -moz-animation: typing 150ms ease-out;
  -o-animation: typing 150ms ease-out;
  animation: typing 150ms ease-out;
}

.sub-title {
  opacity: 0;
  color: grey;
}

.sub-title--fadeIn {
  opacity: 1;
  -webkit-animation: fadeIn 1s ease-out;
  -moz-animation: fadeIn 1s ease-out;
  -o-animation: fadeIn 1s ease-out;
  animation: fadeIn 1s ease-out;
}

@keyframes rubberband {
  0% {
    transform: scaleX(1);
    color: #08fdd8;
  }

  35% {
    transform: scaleX(1.2) scaleY(0.8);
  }

  45% {
    transform: scaleX(1.2) scaleY(0.8);
  }

  55% {
    transform: scaleX(0.8) scaleY(1.2);
  }

  70% {
    transform: scaleX(1.2) scaleY(0.8);
  }

  85% {
    transform: scaleX(0.8) scaleY(1.2);
  }

  100% {
    transform: scaleX(1) scaleY(1);
    color: #08fdd8;
  }
}

@keyframes typing {
  0% {
    opacity: 0;
  }

  50% {
    transform: scaleX(0.75) scaleY(1.25);
  }

  100% {
    opacity: 1;
    transform: scaleX(1) scaleY(1);
  }
}
</style>
